import React from 'react'
import HeroSection from '../Components/HeroSection'
import GetInTouch from '../Components/GetInTouch'
import AboutComponent from '../Components/AboutComponent'
import WhyUs from '../Components/WhyUs'
import ServiceComponent from '../Components/ServiceComponent'
import VissionComponent from '../Components/VissionComponent'
import Stats from '../Components/Stats'

const Home = () => {
  return (
    <>
      <HeroSection />
      <AboutComponent />
      <WhyUs />
      <VissionComponent />
      <ServiceComponent />
      <Stats />
      <GetInTouch />
    </>
  )
}

export default Home
